<div class="box-big col">
    <div class="box-big__icon"><img src="/assets/img/sura-icon-circle-pay.svg" alt="Sura Icon Pay" /></div>
    <div class="box-big__title">
        <h4>{{facturacion.nombreCliente}}, este mes has gastado</h4>
    </div>
    <div class="box-big__price">
        <h2 id="gasto">{{facturacion.totalGastado | currency:"CLP":"$":0:'es_CL' }}</h2>
        <div class="box-big__price--km"><span>Kilómetros recorridos</span><span id="km">{{facturacion.totalKms | number:'1.0':'es-CL'}} kms</span></div>
    </div>
    <div class="box-big__text">
        <a data-toggle="modal" (click)="open(content)">¿Cómo se calcula este precio?</a>
    </div>
</div>
<ng-template #content let-modal>
    <div class="modal-header"><img class="close" src="/assets/img/sura-icon-close.svg" alt="icon" (click)="modal.dismiss()" /></div>
    <div class="modal-body">
        <div class="modal-body-title">
            <h3>¿Cómo se calcula mi precio?</h3>
        </div>
        <div class="modal-body-content">
            <div class="modal-body-content__base">
                <p><strong>Valor fijo mensual</strong></p>
                <div class="modal-body-content__base-precio">
                    <!-- <h2>{{mesGastado.valorFijoTotal | currency:"CLP":"$":0:'es_CL' }}</h2> -->
                    <h2>{{facturacion.valorFijoTotalMensual | currency:"CLP":"$":0:'es_CL' }}</h2>
                </div>
                <div class="modal-body-content__valor">
                    <div class="modal-body-content__valor-base">
                        <p>Valor base</p><span id="valorBase">{{facturacion.valorBaseMensual | currency:"CLP":"$":0:'es_CL' }}</span>
                    </div><img src="/assets/img/sura-icon-plus.svg" alt="SURA ICON PLUS" />
                    <div class="modal-body-content__valor-base">
                        <!-- <p>Valores adicionales*</p><span id="valorAdicional">{{mesGastado.valorTotalAdicional | currency:"CLP":"$":0:'es_CL'}}</span> -->
                        <p>Valores adicionales*</p><span id="valorAdicional">{{facturacion.valoresAdicionales | currency:"CLP":"$":0:'es_CL' }}</span>
                    </div>
                </div>
            </div>
            <div class="modal-body-content__plus"><img src="/assets/img/sura-icon-plus.svg" alt="SURA ICON PLUS" /></div>
            <div class="modal-body-content__kms">
                <p><strong>Precio variable por kilómetro</strong></p>
                <div class="modal-body-content__kms-precio">
                    <div class="modal-body-content__kms-precio-box">
                        <h2>{{facturacion.valorxKM | currency:"CLP":"$":0:'es_CL'}}</h2>
                        <p class="km-text">X KM</p>
                    </div>
                    <p class="adicional">ADICIONAL</p>
                </div>
                <p class="tope">Tope de cobro<br>1300 Kms por mes</p>
            </div>
            <div class="modal-body-content__fijo">
                <div class="modal-body-content__fijo__title">
                    <p><strong>*Valores adicionales</strong></p>
                </div>
                <div class="modal-body-content__fijo-content">
                    <div class="modal-body-content__fijo-tabla">
                        <div class="modal-body-content__fijo-tabla-row">
                            <p>RC</p>
                            <p id="fijoUF">UF {{poliza.rc}}</p>
                        </div>
                        <div class="modal-body-content__fijo-tabla-row">
                            <p>V. DE REEMPLAZO</p>
                            <P id="dias">{{poliza.autoReemplazo}}</P>
                        </div>
                        <div class="modal-body-content__fijo-tabla-row">
                            <p>TIPO DE TALLER</p>
                            <P id="tipoTaller">{{poliza.taller}}</P>
                        </div>
                        <div class="modal-body-content__fijo-tabla-row">
                            <p>ASISTENCIAS</p>
                            <p>{{poliza.tipoAsistencia}}</p>
                        </div>
                    </div>
                    <div class="modal-body-content__fijo-tabla b-left">
                        <p id="precio">{{facturacion.deducibleRc | currency:"CLP":"$ ":0:'es_CL'}}</p>
                        <p id="valor">{{facturacion.deducibleReemplazo | currency:"CLP":"$ ":0:'es_CL'}}</p>
                        <p id="garantia">{{facturacion.deducibleTaller | currency:"CLP":"$ ":0:'es_CL'}}</p>
                        <p id="full">{{facturacion.deducibleAsistencia | currency:"CLP":"$ ":0:'es_CL'}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-body-info">
            <div class="modal-body-info__col left">
                <p>Responsabilidad civil:<span>UF {{poliza.rc}} con <span>{{facturacion.deducibleRc | currency:"CLP":"$ ":0:'es_CL'}}</span></span>
                </p>
                <p>Vehículo de reemplazo:<span> {{poliza.autoReemplazo}} con <span>{{facturacion.deducibleReemplazo | currency:"CLP":"$ ":0:'es_CL'}}</span></span>
                </p>
            </div>
            <div class="modal-body-info__col right">
                <p>Tipo de Taller:<span> {{poliza.taller}} con <span>{{facturacion.deducibleTaller | currency:"CLP":"$ ":0:'es_CL'}}</span></span>
                </p>
                <p>Asistencias:<span> {{poliza.tipoAsistencia}} con <span>{{facturacion.deducibleAsistencia | currency:"CLP":"$ ":0:'es_CL'}}</span></span>
                </p>
            </div>
        </div>
        <div class="modal-body-text">
            <p>El precio de Seguro X KM se calcula sumando un precio base de <strong>{{facturacion.valorBaseMensual | currency:"CLP":"$":0:'es_CL' }}</strong> pesos más un precio variable que depende de los kilómetros que recorras mensualmente. Adicionalmente
                tienes opciones personalizadas que agregan un monto total extra de <strong>{{facturacion.valoresAdicionales | currency:"CLP":"$":0:'es_CL' }}</strong> fijos mensuales, detallados así:</p>
            <p>Por el deducible de {{poliza.deducible}} UF que contrataste, tu precio por kilómetro es de <strong>{{facturacion.valorxKM | currency:"CLP":"$":0:'es_CL'}} pesos</strong>. <br>Si manejas mucho <strong>solo pagarás un máximo mensual de {{facturacion.valorMensualMaximo | currency:"CLP":"$":0:'es_CL'}} pesos</strong>                (correspondiente a {{facturacion.kilometroMaximo}} KM) por tu prima variable.</p>
            <p>Es muy común que las redes móviles tengan problemas de señal algunas veces. Debido a esto, en algunos casos ver y procesar los viajes puede demorar más de lo habitual. Si finalizas tu ciclo mensual mientras aún se procesan tus últimos viajes
                es posible que se cobren al mes siguiente al facturado.</p>
        </div>
    </div>
</ng-template>
